import { render, staticRenderFns } from "./NowTime.vue?vue&type=template&id=50b63bf5&scoped=true&"
import script from "./NowTime.vue?vue&type=script&lang=js&"
export * from "./NowTime.vue?vue&type=script&lang=js&"
import style0 from "./NowTime.vue?vue&type=style&index=0&id=50b63bf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b63bf5",
  null
  
)

export default component.exports